import styled from "styled-components";

export const Container = styled.i`
  font-size: ${(props) => props.size || "18px"};
  color: ${(props) => props.color || "#1787e0"};
`;
